const api = '/api/v1/u002_p_item_detail_controller.php';
import axios from 'axios';
export const item_detail_repository =  {
    get(item_id){
        return  axios.get(`${api}?ITEM_ID=${item_id}`);
    },
    upd(data){
        data.type = 'upd';
        return  axios.post(api, data);
    },
    discount(data){
        data.type = 'discount';
        return  axios.post(api, data);
    }
};

